import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import CoreProductActionsBlockData from '../../../Models/Content/CoreProductActionsBlockData';
import CoreProductActionsMain from './CoreProductActionsMain'


export default class PopupBenefitBlock extends EpiComponent<CoreProductActionsBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <CoreProductActionsMain context={this.getContext()} iContent={this.props.data} />
  }
}
